import { FILTER_TYPES, PROGRESS_STATUS } from '../../../constants/TopFilterConstants';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from '../../../hooks/searchParamHooks';
import UsageTracker from '../../../utils/UsageTracker';
import { Select } from 'foundations-components/components/Select';
import { FiltersWrapper } from './FiltersWrapper';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const getOptions = () => PROGRESS_STATUS.map(progressStatus => ({
  text: I18n.text(`academyComponents.topFilters.progressStatus.${progressStatus}`),
  value: progressStatus
}));
export const ProgressFilter = ({
  appearsIn
}) => {
  const [progressType, setProgressType] = useSearchParam(FILTER_TYPES.PROGRESS_STATUS);
  const handleProgressTypeChange = value => {
    UsageTracker.trackStandalone('Filter Interaction', {
      action: value ? 'filter-selected' : 'filter-deselected',
      value,
      isDropdown: true,
      key: 'progress-filter',
      appearsIn
    });
    setProgressType(value);
  };
  return /*#__PURE__*/_jsx(FiltersWrapper, {
    children: /*#__PURE__*/_jsx(Select, {
      clearable: true,
      "data-test-id": "filter-type-progressStatus",
      menuInlineSize: 200,
      onSelectedOptionChange: evt => {
        handleProgressTypeChange(evt.value);
      },
      options: getOptions(),
      prefixWithSelectedItemsPlaceholder: true,
      selectedItemsPlaceholder: I18n.text('academyComponents.topFilters.progressStatus.filterTitle'),
      selectedValues: progressType
    })
  });
};